if (document.querySelector('#mapbox')) {

  // svgstore function
  var svgstore = function(svg, title, classes) {
    var titleTag = '';
    var classesList = '';
    var html = '';
    if (title) {
      titleTag = '<title>' + title + '</title>';
    }
    if (classes) {
      classesList = classes + ' ';
    }
    html = '<span class="' + classesList + 'svgstore svgstore--' + svg + '"><svg>' + titleTag + '<use xlink: href="' + svgstoreURL + '#' + svg + '"></use></svg></span>';
    return html;
  }

  // hide sidebar for smaller viewports
  var hideSidebar = function() {
    var activeSidebar = document.querySelector('.map__sidebar--active');
    if (activeSidebar && window.innerWidth < 1024) {
      activeSidebar.classList.remove('map__sidebar--active');
    }
  }

  // simple node.remove() polyfill
  if (!('remove' in Element.prototype)) {
    Element.prototype.remove = function() {
      if (this.parentNode) {
        this.parentNode.removeChild(this);
      }
    };
  }

  // toggle map sidebar
  var toggle = document.querySelector('.map__toggle');
  toggle.addEventListener('click', function() {
    this.parentNode.classList.toggle('map__sidebar--active');
  });

  // set mapbox accessToken
  mapboxgl.accessToken = accessToken;

  // setup map bounds based on geojson data
  var bounds = new mapboxgl.LngLatBounds();
  var boundsNetwork = new mapboxgl.LngLatBounds();
  clubs.features.forEach(function(feature) {
    if (feature.properties.state === 'VA' || feature.properties.state === 'DC' || feature.properties.state === 'MD') {
      bounds.extend(feature.geometry.coordinates);
    }
    boundsNetwork.extend(feature.geometry.coordinates);
  });

  // function to activate a nav item
  var activateItem = function(button) {
    var activeItem = document.querySelectorAll('.map__button--active');
    if (activeItem[0]) {
      activeItem[0].classList.remove('map__button--active');
    }
    if (button) {
      button.classList.add('map__button--active');
    }
    hideSidebar();
  }

  // function to build out map navigation
  var buildNav = function(data) {
    for (i = 0; i < data.features.length; i += 1) {
      var feature = data.features[i];
      if (feature.properties.state === 'VA' || feature.properties.state === 'DC' || feature.properties.state === 'MD') {
        var prop = feature.properties;
        var nav = document.querySelector('.map__nav');
        var button = nav.appendChild(document.createElement('button'));
        button.classList.add('map__button');
        button.id = 'mapbox-button-' + i;
        button.dataPosition = i;
        button.innerHTML = prop.name;
        // fly to a location and create a popup on button click
        button.addEventListener('click', function () {
          var clickedButton = data.features[this.dataPosition];
          createPopup(clickedButton);
          activateItem(this);
          flyToMarker(clickedButton);
        });
      }
    }
  };

  // function to fly to a marker
  var flyToMarker = function(feature) {
    var coords = feature.geometry.coordinates.slice(0);
    coords[1] += 0.025;
    map.flyTo({
      center: coords,
      zoom: 12,
    });
  };

  // function to remove popup
  var removePopup = function() {
    var popups = document.querySelectorAll('.mapboxgl-popup');
    if (popups[0]) {
      popups[0].remove();
    }
  };

  // function to create popup
  var createPopup = function(feature) {
    var classes = '';
    var prop = feature.properties;
    removePopup();
    if (prop.state !== 'VA' && prop.state !== 'DC' && prop.state !== 'MD') {
      classes = ' map__detail--alt';
    }
    var logo = svgstore(prop.logo, prop.name, 'map__club-logo');
    if (prop.logo_image) {
      logo = '<img class="map__club-logo" src="' + prop.logo_image + '" alt="' + prop.name + '">';
    }
    var social = '';
    if (prop.facebook) {
      var facebook = '<a class="map__social__link" href="' + prop.facebook + '" target="_blank">' + svgstore('facebook', 'Facebook') + '</a>';
      social = social + facebook;
    }
    if (prop.instagram) {
      var instagram = '<a class="map__social__link" href="' + prop.instagram + '" target="_blank">' + svgstore('instagram', 'Instagram') + '</a>';
      social = social + instagram;
    }
    if (prop.twitter) {
      var twitter = '<a class="map__social__link" href="' + prop.twitter + '" target="_blank">' + svgstore('twitter', 'Twitter') + '</a>';
      social = social + twitter;
    }
    if (prop.email) {
      var email = '<a class="map__social__link" href="mailto:' + prop.email + '" target="_blank">' + svgstore('envelope', 'Email') + '</a>';
      social = social + email;
    }
    var popup = new mapboxgl.Popup({closeOnClick: false, anchor: 'bottom'})
      .setLngLat(feature.geometry.coordinates)
    .setHTML(logo + '<ul class="map__detail' + classes + '"><li class="map__detail__item">' + svgstore('map-marker', 'Map Marker Icon', 'map__detail__icon') + prop.address + '<br>' + prop.city + ', ' + prop.state + ' ' + prop.zip + '</li></ul>' + '<div class="map__social">' + social + '</div>')
      .addTo(map);
    popup.on('close', function() {
      activateItem();
    });
  };

  // create map and fit initial bounds
  var map = new mapboxgl.Map({
    container: 'mapbox',
    style: 'mapbox://styles/joshandersonfoundation/cjic9l4mg09sb2qofgfg8l0no',
  }).fitBounds(bounds, {padding: 64, duration: 0});

  // add clubs geojson locations layer and zoom control to map
  map.on('load', function(e) {
    map.addSource('places', {
      type: 'geojson',
      data: clubs,
    });
    map.addControl(new mapboxgl.NavigationControl({showCompass: false}), 'bottom-right');
    buildNav(clubs);
  });

  // hide sidebar on map drag
  map.on('dragstart', hideSidebar);

  // add custom markers
  clubs.features.forEach(function(marker, i) {
    var el = document.createElement('div');
    el.classList.add('map__marker');
    if (marker.properties.state !== 'VA' && marker.properties.state !== 'DC' && marker.properties.state !== 'MD') {
      el.classList.add('map__marker--alt');
    }
    new mapboxgl.Marker(el)
      .setLngLat(marker.geometry.coordinates)
      .addTo(map);
    // show popups on hover
    el.addEventListener('mouseenter', function() {
      var button = document.querySelector('#mapbox-button-' + i);
      createPopup(marker);
      activateItem(button);
    });
    // fly to a location and create a popup on marker click
    el.addEventListener('click', function() {
      var button = document.querySelector('#mapbox-button-' + i);
      createPopup(marker);
      activateItem(button);
      flyToMarker(marker);
    });
  });

  // view full network
  var network = document.querySelector('.map__network');
  network.addEventListener('click', function() {
    removePopup();
    activateItem();
    map.fitBounds(boundsNetwork, { padding: 64 });
  });

}
